import React, { useCallback, useEffect, useState } from 'react'

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as UserSettingsIcon } from 'assets/icons/user_settings.svg';
import { useTranslation } from 'react-i18next';
import CustomSelect from 'components/CustomSelect';
import UserModal from './modals/UserModal';
import { GET, httpOk } from 'helpers/api';
import FilterSearch from 'components/FilterSearch';
import FilterDropdown from 'components/FilterDropdown';
import { roles } from 'helpers/helpers';

function UsersManagement() { // Переименовал функцию для соответствия смыслу
	const { t } = useTranslation()

	const [userModal, setUserModal] = useState(false)
	const [dropdown, setDropdown] = useState(false)

	const [filterData, setFilterData] = useState({})
	const [data, setData] = useState([])

	const statuses = [
		{ id: true, name: t('active') },
		{ id: false, name: t('not_active') },
	];

	const rolesDescriptions = [
		{ title: t('raw_warehouse_worker'), desc: t('raw_warehouse_worker_desc'), color: '#2B7FFF' },
		{ title: t('production_worker'), desc: t('production_worker_desc'), color: '#AD46FF' },
		{ title: t('fg_warehouse_worker'), desc: t('fg_warehouse_worker_desc'), color: '#00C950' },
		{ title: t('technologist'), desc: t('technologist_desc'), color: '#FF6900' },
		{ title: t('sales_department'), desc: t('sales_department_desc'), color: '#F6339A' },
		{ title: t('management'), desc: t('management_desc'), color: '#6A7282' },
	];

	const getData = useCallback(async () => {
		const [response, responseStats] = await Promise.all([
			GET('/users/management/users/', filterData),
			GET('/users/management/users/stats/', filterData)
		]);

		if (httpOk(response)) {
			setData({ ...response.data, ...responseStats.data });
		}
	}, [filterData]);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<>
			<div className="d-between">
				<div>
					<div className="main-content-title">
						{t('users_and_roles')}
					</div>

					<div className="main-content-subtitle">
						{t('user_management_desc')}
					</div>
				</div>

				<div className="d-flex gap-8">
					<button className="dark gap-16" onClick={() => setUserModal(true)}>
						<PlusIcon />
						{t('add_user')}
					</button>

					<UserModal modal={userModal} setModal={setUserModal} reload={getData} />
				</div>
			</div>

			<div className="grid4 gap-16">
				<div className="card">
					<div className="title">{t('total_users')}</div>
					<div className="value">{data.total || 0}</div>
				</div>

				<div className="card">
					<div className="title">{t('active_users')}</div>
					<div className="value text-success">{data.active || 0}</div>
				</div>

				<div className="card">
					<div className="title">{t('sales_department')}</div>
					<div className="value">{data.sales_count || 0}</div>
				</div>

				<div className="card">
					<div className="title">{t('technologists')}</div>
					<div className="value">{data.technologists_count || 0}</div>
				</div>
			</div>

			<div className="card">
				<div className="d-flex gap-16 w-100">
					<FilterSearch
						value={filterData.user_name}
						onChange={(e) => setFilterData({ ...filterData, user_name: e.target.value })}
						placeholder={t('search_by_name')}
					/>

					<CustomSelect
						options={statuses}
						value={statuses.find(option => option.id === filterData?.is_active) || ''}
						onChange={(option) => setFilterData({ ...filterData, is_active: option?.id })}
						getOptionLabel={(option) => option.name}
						getOptionValue={(option) => option.id}
						placeholder={t('status')}
					/>

					<CustomSelect
						options={roles}
						value={roles.find(option => option.id === filterData?.role) || ''}
						onChange={(option) => setFilterData({ ...filterData, role: option?.id })}
						getOptionLabel={(option) => option.name}
						getOptionValue={(option) => option.id}
						placeholder={t('role')}
					/>

					<FilterDropdown dropdown={dropdown} setDropdown={setDropdown}>
						<div className="form-group">
							<label htmlFor="name">{t('full_name')}</label>
							<input type="text" id="name" autoComplete='off' />
						</div>
					</FilterDropdown>
				</div>
			</div>

			<div className="card">
				<div className="d-between mb-30">
					<div className="fz16 text-third">
						{t('users_list')}
					</div>
				</div>

				<table className="table">
					<thead>
						<tr>
							<th style={{ width: '30%' }}>{t('name2')}</th>
							<th style={{ width: '30%' }}>{t('role')}</th>
							<th style={{ width: '15%' }}>{t('status')}</th>
							<th style={{ width: '25%' }}>{t('actions')}</th>
						</tr>
					</thead>

					<tbody>
						{data?.results?.map((item, index) => (
							<tr key={index}>
								<td>{item.user_name}</td>
								<td>{t(item.role?.toLowerCase())}</td>
								<td>
									<div className={`alert ${item.is_active ? 'alert-success' : 'alert-danger'} w-fit-content`}>
										{item.is_active ? t('active') : t('not_active')}
									</div>
								</td>
								<td>
									<div className="d-flex align-items-center gap-8">
										<button className="white small">
											<UserSettingsIcon />
											{t('change_roles')}
										</button>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className="card">
				<div className="mb-30">
					<div className="fz16 text-third">
						{t('roles_description')}
					</div>
				</div>

				<div className="d-flex flex-column gap-16">
					{rolesDescriptions.map((role, idx) => (
						<div key={idx} className="d-flex flex-column gap-5" style={{ borderLeft: `4px solid ${role.color}`, padding: '8px 20px' }}>
							<div className="fz16 text-third">
								{role.title}
							</div>
							<span className="text-second">
								{role.desc}
							</span>
						</div>
					))}
				</div>
			</div>
		</>
	)
}

export default UsersManagement;